export const fieldDefinitions = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_FIELD_DEFINITIONS': {
      const newState = { ...state };
      const { surveyId, fieldDefinitions: definitions } = action.payload;

      newState[surveyId] = newState[surveyId] || {};

      definitions.forEach((fieldDefinition) => {
        newState[surveyId][fieldDefinition.id] = fieldDefinition;
      });

      return newState;
    }
    case 'REMOVE_FIELD_DEFINITIONS': {
      const newState = { ...state };
      const { surveyId, fieldDefinitions: definitions } = action.payload;

      definitions.forEach((fieldDefinition) => {
        delete newState[surveyId][fieldDefinition.id];
      });

      return newState;
    }
    default:
      return state;
  }
};
